import "D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\core-js\\modules\\es.array.iterator.js";
import "D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\core-js\\modules\\es.promise.js";
import "D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\core-js\\modules\\es.object.assign.js";
import "D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\core-js\\modules\\es.promise.finally.js";
// Vue
import Vue from 'vue';
import i18n from './i18n';
import App from './App';
import util from '@/libs/util'; // 核心插件

import d2Admin from '@/plugin/d2admin'; // store

import store from '@/store/index';
import VXETable from 'vxe-table';
import VXETablePluginExportXLSX from 'vxe-table-plugin-export-xlsx';
import 'vxe-table/lib/style.css';
import 'xe-utils';
console.log('VXETable', VXETable);
VXETable.use(VXETablePluginExportXLSX); // 菜单和路由设置

import router from './router';
import { menuHeader, menuAside } from '@/menu';
import { frameInRoutes } from '@/router/routes';
import MesTable from '@/components/MesTable';
import MesColumn from '@/components/MesColumn';
import Bus from '@/libs/bus'; // 按钮权限

import { hasBtnPermiss } from '@/libs/hasBtnPermiss'; // import '@/mock/index.js'
// 拖拽

import './libs/directives'; // loading

import { openLoading, closeLoading } from './libs/util.loading'; // 全局混入状态管理

import StatusMixin from './mixins/StatusMixin';
import JsonExcel from 'vue-json-excel';
Vue.component('MesTable', MesTable);
Vue.component('MesColumn', MesColumn);
Vue.component('downloadExcel', JsonExcel);
Vue.prototype.$hasBtnPermiss = hasBtnPermiss;
Vue.prototype.$openLoading = openLoading;
Vue.prototype.$closeLoading = closeLoading; // Vue.prototype.$setOrderStatu = (status)=>{
//   console.log('route',this.$route);
//   let route = this.$route.path.substr(1) + '/setOrderStatu'
//   return this.$store.dispatch(route,status)
// }

var packageInfo = require('../package.json'); // 核心插件


Vue.use(d2Admin);
Vue.use(Bus); // VXETable.Table.props.size = {type:String, default:'medium'}

Vue.use(VXETable);
Vue.use(StatusMixin);
Vue.mixin({
  computed: {
    $btnList: function $btnList() {
      // console.log('$btnList',store.state.custom.permission.btnList);
      return store.state.custom.permission.btnList || [];
    },
    $tableTools: function $tableTools() {
      return store.state.custom.permission.tableTools || false;
    }
  }
});

var handleUploadHeader = function handleUploadHeader() {
  var config = {};
  var token = util.cookies.get('token') || ''; // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改

  config.Authorization = "Bearer ".concat(token);
  var lang = {
    'zh-chs': 'zh-CN,zh;',
    en: 'en-US,en;'
  };
  config['Accept-Language'] = lang[util.cookies.get('lang')];
  return config;
};

Vue.prototype.handleUploadHeader = handleUploadHeader;
Vue.prototype.$packageInfo = packageInfo;
new Vue({
  router: router,
  store: store,
  i18n: i18n,
  render: function render(h) {
    return h(App);
  },
  created: function created() {
    // 处理路由 得到每一级的路由设置
    this.$store.commit('d2admin/page/init', frameInRoutes); // 设置顶栏菜单

    this.$store.commit('d2admin/menu/headerSet', menuHeader); // 初始化菜单搜索功能

    this.$store.commit('d2admin/search/init', menuHeader);
  },
  mounted: function mounted() {
    // 展示系统信息
    this.$store.commit('d2admin/releases/versionShow'); // 用户登录后从数据库加载一系列的设置

    this.$store.dispatch('d2admin/account/load'); // 获取并记录用户 UA

    this.$store.commit('d2admin/ua/get'); // 初始化全屏监听

    this.$store.dispatch('d2admin/fullscreen/listen');
  },
  watch: {
    // 检测路由变化切换侧边栏内容
    '$route.matched': {
      handler: function handler(matched) {
        var route = this.$route;
        this.$store.commit('custom/routerInfo/SET_ROUTER_PATH', route.fullPath);
      },
      immediate: true
    }
  }
}).$mount('#app2');